import { merge } from 'lodash';
import { defaultTheme } from 'tuui';

export const realizeTheme = (() => {
    const testPrimaryColor = '#4d86ec';
    const difference = {
        palette: {
            primary: {
                fill: testPrimaryColor,
                stroke: testPrimaryColor,
            },
            secondary: {
                fill: testPrimaryColor,
                stroke: testPrimaryColor,
            },
            info: {
                fill: testPrimaryColor,
                stroke: testPrimaryColor,
            },
        },
    };
    const tempTheme = merge({}, defaultTheme, difference);

    return tempTheme;
})();
